import 'core-js'

import Vue from 'vue'
import VueRouter from 'vue-router'

import axios from 'axios'

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

import BaseComponent from './components/base.vue'
import NotFoundComponent from './components/notfound.vue'
import HomeComponent from './components/home.vue'
import LoginComponent from './components/login.vue'

import store from './store'

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import * as push from 'push.js'

import moment from 'moment'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Vue.component('datetime', Datetime)
Vue.component('icon', Icon)
Vue.component('vue-timepicker', VueTimepicker)

// Hydrate the store with saved credentials
store.commit('hydrate')

// Check for env set by previous script
if (!window.env)
    throw new Error('no env.js file!')

// start bugsnag
if (env.bugnsag_key){
    Bugsnag.start({
        apiKey: env.bugsnag_key,
        plugins: [new BugsnagPluginVue(Vue)],
    })
}

// Strip trailing slash from base_url
if (env.base_url.substr(-1) === '/')
    env.base_url = env.base_url.substr(0, env.base_url.length - 1)

// Add live reload script if required
if (env.environment != 'prod') {
	const el = document.createElement('script')
	el.setAttribute('src', 'http://localhost:35735/livereload.js')

	document.body.appendChild(el)
}

const app = {
	moment,
	push,
	loading: false,
	http: {
		get: (url, data, settings) => http('get', url, data, settings),
		post: (url, data, settings) => http('post', url, data, settings),
		patch: (url, data, settings) => http('patch', url, data, settings),
		delete: (url, data, settings) => http('delete', url, data, settings),
	},
}

// Axios shim
axios.defaults.baseURL = env.base_url

const http = function(method, url, data = false, settings = {}) {
	const axios_settings = settings
	axios_settings['method'] = method
	axios_settings['url'] = url
	if (data && method.toLowerCase() == 'get')
	    axios_settings['params'] = data
	else if (data)
	    axios_settings['data'] = data

	const headers = {
		'App': 'goodeats_terminal',
		'Device-Id': store.getters.install_id,
	}
	if (store.getters.token)
	    headers['Authorization'] = `Bearer ${store.getters.token}`
	axios_settings['headers'] = headers

	return new Promise((resolve, reject) => {
		// We're loading!
		if (!['order_collect/get_sales', 'device', 'refresh_token'].includes(axios_settings.url)) {
			store.commit('setLoading', true)
		}

		axios(axios_settings)
			.then(function(response) {
				// No longer loading
				store.commit('setLoading', false)

				// All good!
				resolve(response)
			})
			.catch(function(error) {
				if (axios_settings.url.includes('login') == false && [401, 403].includes(error.response.status)) {
					store.commit('logout')
					return
				}

				console.error('global http error', error)

				// No longer loading
				store.commit('setLoading', false)

				reject(error)
			})
	})
}

// Configure Vue
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		component: BaseComponent,
		children: [
			{
				path: '',
				name: 'home',
				component: HomeComponent,
			},
			{
				path: 'login',
				name: 'login',
				component: LoginComponent,
			},
			{
				path: '*',
				component: NotFoundComponent,
			},
		],
	},
]

const router = new VueRouter({
	routes,
	mode: 'history',
})

new Vue({
	router,
	store,
	data: {
		app,
	},
}).$mount('#app')

// Allow configuring devtools from env
if (env.environment != 'prod') {
	Vue.config.devtools = true
	Vue.config.silent = false
}
